import RecentArticle from './RecentArticle'
import UseFetch from '../../UseFetch'
import mainData from '../../FetchDataLinks'
import RecentArticleSkeleton from './RecentArticleSkeleton'

function RecentPosts() {

    let a = 0;

    const { blogs, loading } = UseFetch(mainData.recentBlogs)

    return (
        <div className="sidebar-widget popular-posts">
            <div className="sidebar-title">
                <h4>Recent Posts</h4>
            </div>
            {loading && Array(3).fill().map(() => {
                a++;
                return <RecentArticleSkeleton key={a} />
            })}
            {!loading && blogs.map((blog) => {
                return <RecentArticle key={blog.id} slug={blog.slug} image={blog.Image} PostHeading={blog.Headline} date={blog.date} />
            })}
        </div>
    )
}

export default RecentPosts
